export default __webpack_public_path__ + "static/media/icon-comment-exclamation.e2c3026d.svg";